import { lazy } from 'react';

export const PaymentList = lazy(() => import('./payment/PaymentList'));
export const ChargesList = lazy(() => import('./charges/ChargesList'));
